import { Progress } from 'antd';
import useSceneStore from '../../stores/sceneStore';

/**
 * 2026-09-14｜模型加载进度条（贴图重载/首次大模型加载）
 * 设计：加载期间**保持当前模型与镜头不变**，屏幕上方显示进度条，加载完成自动消失（原子切换）
 */
export default function ModelLoadingBar() {
  const ml = useSceneStore((s) => s.modelLoading);
  if (!ml?.active) return null;
  // 2026-09-14：分阶段——download 显示真实百分比；parse（下载完成/停滞）显示不确定进度动画 + 说明
  const isParse = ml.phase === 'parse';
  return (
    <div
      style={{
        position: 'fixed',
        top: 64,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 3500,
        width: 340,
        background: 'rgba(15,15,26,0.92)',
        border: '1px solid #30475e',
        borderRadius: 8,
        padding: '10px 14px',
        boxShadow: '0 6px 18px rgba(0,0,0,0.5)',
      }}
    >
      <div style={{ fontSize: 12, color: '#9ecbff', marginBottom: 6 }}>
        {isParse
          ? '模型解析中…（大模型约 1~3 分钟，界面可能暂时无响应）'
          : `模型下载中… ${ml.progress}%`}
        <span style={{ color: '#666', marginLeft: 8 }}>（当前画面与视角保持不变）</span>
      </div>
      {isParse ? (
        <Progress status="active" size="small" strokeColor="#1890ff" showInfo={false} />
      ) : (
        <Progress percent={ml.progress} size="small" strokeColor="#1890ff" showInfo={false} />
      )}
    </div>
  );
}
